import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Card, Form, Input, Select, DatePicker, Button, Row, Col, Space, InputNumber, Switch, } from "antd";
import { SearchOutlined, ReloadOutlined, DownOutlined, UpOutlined, } from "@ant-design/icons";
const { RangePicker } = DatePicker;
const { Option } = Select;
/**
 * 通用搜索面板组件
 */
const GenericPanelSearch = ({ 
// 定义通用搜索面板组件
title = "搜索条件", // 设置默认标题
searchItems = [], // 设置默认搜索项为空数组
columns = 3, // 设置默认列数为3
onSearch, // 设置搜索回调
onReset, // 设置重置回调
extraButtons = [], // 设置默认额外按钮为空数组
collapsible = true, // 默认可折叠
defaultCollapsed = false, // 默认展开状态
labelWidth = 100, // 默认标签宽度为100px
 }) => {
    const [form] = Form.useForm();
    const [collapsed, setCollapsed] = useState(defaultCollapsed);
    // 处理搜索
    const handleSearch = () => {
        console.log("[GenericPanelSearch] 搜索按钮被点击");
        form
            .validateFields()
            .then((values) => {
            console.log("[GenericPanelSearch] 表单验证成功，搜索值:", values);
            onSearch(values);
        })
            .catch((errorInfo) => {
            console.log("[GenericPanelSearch] 表单验证失败:", errorInfo);
            // 即使验证失败，也执行搜索（使用当前表单值）
            const currentValues = form.getFieldsValue();
            console.log("[GenericPanelSearch] 使用当前表单值进行搜索:", currentValues);
            onSearch(currentValues);
        });
    };
    // 重置表单
    const handleReset = () => {
        console.log("[GenericPanelSearch] 重置按钮被点击");
        form.resetFields();
        console.log("[GenericPanelSearch] 表单已重置");
        // 如果有onReset回调，优先调用onReset，否则执行空搜索
        if (onReset) {
            console.log("[GenericPanelSearch] 调用onReset回调");
            onReset();
        }
        else {
            console.log("[GenericPanelSearch] 执行空搜索");
            onSearch({});
        }
    };
    // 切换折叠状态
    const toggleCollapse = () => {
        setCollapsed(!collapsed);
    };
    // 计算每个表单项占用的列数
    const getColSpan = (item) => {
        if (item.colSpan)
            return item.colSpan;
        return 24 / columns;
    };
    // 根据折叠状态确定显示的项目
    const visibleItems = collapsed && collapsible ? searchItems.slice(0, columns) : searchItems;
    // 渲染搜索控件
    const renderFormItem = (item) => {
        const { type, options, props = {}, customComponent } = item;
        switch (type) {
            case "input":
                return _jsx(Input, { allowClear: true, ...props });
            case "select":
                return (_jsx(Select, { allowClear: true, ...props, children: options?.map((opt) => (_jsx(Option, { value: opt.value, children: opt.label }, opt.value))) }));
            case "date":
                return _jsx(DatePicker, { style: { width: "100%" }, ...props });
            case "dateRange":
                return _jsx(RangePicker, { style: { width: "100%" }, ...props });
            case "number":
                return _jsx(Input, { type: "number", allowClear: true, ...props });
            case "inputNumber": // 添加这个 case
                return _jsx(InputNumber, { style: { width: "100%" }, ...props });
            case "switch":
                return _jsx(Switch, { ...props });
            case "custom":
                if (customComponent) {
                    const CustomComponent = customComponent;
                    return _jsx(CustomComponent, { ...props });
                }
                return _jsx(Input, { allowClear: true, ...props });
            default:
                return _jsx(Input, { allowClear: true, ...props });
        }
    };
    // 构建所有操作按钮
    const actionButtons = (_jsxs(Space, { children: [collapsible && searchItems.length > columns && (_jsx(Button, { type: "link", onClick: toggleCollapse, icon: collapsed ? _jsx(DownOutlined, {}) : _jsx(UpOutlined, {}), style: {
                    color: "#1890ff",
                }, children: collapsed ? "更多" : "收拢" })), _jsx(Button, { icon: _jsx(ReloadOutlined, {}), size: "small", onClick: handleReset, style: {
                    color: "#1890ff",
                    borderColor: "#1890ff",
                    fontSize: "12px",
                }, children: "\u91CD\u7F6E" }), _jsx(Button, { type: "primary", size: "small", icon: _jsx(SearchOutlined, {}), onClick: handleSearch, style: {
                    fontSize: "12px",
                }, children: "\u641C\u7D22" })] }));
    // 计算标签宽度的样式
    const labelColStyle = {
        width: typeof labelWidth === "number" ? `${labelWidth}px` : labelWidth,
        textAlign: "right",
    };
    return (_jsx(Card, { title: _jsx("span", { style: { color: "#1f1f1f", fontWeight: 500 }, children: title }), extra: actionButtons, className: "search-panel", styles: { body: { padding: "24px 24px 0 24px" } }, children: _jsx(Form, { form: form, layout: "horizontal", children: _jsx(Row, { gutter: 16, children: visibleItems.map((item) => (_jsx(Col, { span: getColSpan(item), style: { marginBottom: 16 }, children: _jsx(Form.Item, { name: item.name, label: _jsx("span", { style: { color: "#1f1f1f" }, children: item.label }), style: { marginBottom: 0 }, 
                        // 应用固定宽度到标签
                        labelCol: { style: labelColStyle }, initialValue: item.initialValue, children: renderFormItem(item) }) }, item.name))) }) }) }));
};
export default GenericPanelSearch;
